import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSiteAdminControlsLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSiteAdminControls" */ './components/ShareableLinkSiteAdminControls.tsx'
			)
		).ShareableLinkSiteAdminControls,
});
